import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  inject,
  input,
  output,
  signal,
} from '@angular/core';

import {
  AlertsComponent,
  AlertsService,
  NotImplementedYetService,
  PrimengButtonDirective,
  SocialIconComponent,
  SocialIconType,
} from '@web/shared/ui';
import { SignUpAsClientFormComponent } from '../../components/sign-up-as-client-form/sign-up-as-client-form.component';
import { SignUpAsClientForm } from '../../models/sign-up-as-client-form';
import { FormTitleWithSubtitleComponent } from '../../ui/form-title-with-subtitle/form-title-with-subtitle.component';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { HttpErrorService } from '@web/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Button } from 'primeng/button';
import { SignUpService } from '../../services/sign-up.service';

@Component({
  selector: 'app-sign-up-as-client',
  imports: [
    FormTitleWithSubtitleComponent,
    SignUpAsClientFormComponent,
    SocialIconComponent,
    AlertsComponent,
    Button,
    PrimengButtonDirective,
  ],
  templateUrl: './sign-up-as-client.component.html',
  styleUrl: './sign-up-as-client.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [AlertsService],
})
export class SignUpAsClientComponent {
  private readonly signUp = inject(SignUpService);
  private readonly notImplementedYet = inject(NotImplementedYetService);
  private readonly httpError = inject(HttpErrorService);
  private readonly alerts = inject(AlertsService);

  public readonly shouldShowSocials = input(false);
  public readonly navigateToSignInPageEvent = output();

  protected readonly isFormVisible = signal<boolean>(true);
  protected readonly SocialIconType = SocialIconType;

  private readonly destroyRef = inject(DestroyRef);

  public handleSignUpByFacebookClick(): void {
    this.notImplementedYet.showToast();
  }

  public handleSignUpByGoogleClick(): void {
    this.notImplementedYet.showToast();
  }

  public handleSubmitClickEvent(form: SignUpAsClientForm): void {
    this.signUp
      .signUpAsClient(form)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: () => {
          this.showSuccessAlert();
          this.markFormAsInvisible();
        },
        error: (response) => {
          this.showFailureAlertByResponse(response);
        },
      });
  }

  public handleNavigateToSignInPageClick(): void {
    this.navigateToSignInPageEvent.emit();
  }

  public showSuccessAlert(): void {
    this.alerts.showSingle((builder) =>
      builder
        .initSuccess(
          'Dziękujemy za założenie konta. Aby dokończyć proces rejestracji, prosimy o aktywację Twojego konta. Instrukcje dotyczące aktywacji zostały wysłane na Twój adres e-mail. Sprawdź swoją skrzynkę pocztową i postępuj zgodnie z przesłanymi informacjami.',
        )
        .closeable(false)
        .build(),
    );
  }

  private showFailureAlertByResponse(response: HttpErrorResponse): void {
    const messages = this.httpError.extract(response).messages();

    this.alerts.showMultiple((builder) =>
      messages.map((content) => builder.buildFailure(content)),
    );
  }

  private markFormAsInvisible(): void {
    this.isFormVisible.set(false);
  }
}
